mutation RegenerateDafStatements($ids: [ID!]!) {
  regenerateDafStatements(input: { ids: $ids }) {
    success
  }
}
